module.exports = __webpack_public_path__ + "public/images/netw-start-conversation-desktop.02f4affbf28769a31b68792c871dc1b4.jpg";